import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { completeGoogleLogin, googleDestination, googleSessionExchange, rejectGoogleLogin } from "@/lib/googleAuth";

export const useGoogleCallback = () => {
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  const exchange = useRef(null);
  const isAdmin = pathname.replace(/\/+$/, "") === "/admin";

  useEffect(() => {
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate(googleDestination(isAdmin), { replace: true });
      return;
    }
    let active = true;
    // One shared promise survives StrictMode replay. Only the current observer
    // may navigate, so a superseded session cannot overwrite a newer login.
    googleSessionExchange(exchange, sessionId, isAdmin)
      .then(({ data }) => { if (active) completeGoogleLogin(data, isAdmin, navigate); })
      .catch((error) => { if (active) rejectGoogleLogin(error, isAdmin, navigate); });
    return () => { active = false; };
  }, [hash, isAdmin, navigate]);
};